function waitForElement(selector, timer = 30000, frequency = 100) {
  return new Promise((resolve, reject) => {
    let element = document.querySelector(selector);
    if (timer <= 0)
      return reject(
        `waitForElement | Couldn't find element with selector: ${selector}`
      );
    if (element) return resolve(element);
    setTimeout(() => {
      waitForElement(selector, timer - frequency, frequency)
        .then(resolve)
        .catch(reject);
    }, frequency);
  });
}

waitForElement("#cart-drawer .flow-root > ul > li.flex").then((element) => {
  function setDefaultRadioSelection(sellingPlan, subscriptionDiv) {
    const checkedValue = sellingPlan ? 'subscription' : 'one-time';
    subscriptionDiv.querySelector(`input[value="${checkedValue}"]`).checked = true;
  }

  async function appendNewImage(li) {
    const selectHref = li.querySelector("h4 a").href;
    let currentImage = li.querySelector("img");
    currentImage.style.display = "none";
    let cwNewImage = li.querySelector(".cw-new-image");
    const urlParams = new URLSearchParams(selectHref.split('?')[1]);
    const variantId = urlParams.get('variant');
    let imageSrc = `//aktlondon.com/cdn/shop/files/${variantId}.png`
    if (!cwNewImage) {
      const newImage = document.createElement('img');
      newImage.setAttribute('width', '80');
      newImage.setAttribute('height', '104');
      newImage.classList.add('w-20', 'cw-new-image');
      newImage.src = imageSrc;
      currentImage.insertAdjacentElement('afterend', newImage);
    } else {
      // cwNewImage.src = imageSrc;
      let interval = setInterval(() => {
        cwNewImage.src = imageSrc;
      }, 100);

      setTimeout(() => {
        clearInterval(interval);
      }, 2000);
    }
  }

  async function initializeSubscriptionProduct(li, index) {
    const selectHref = li.querySelector("h4 a").href;
    const selectQty = li.querySelector(".item-data-wrapper .item-qty-input").value;
    const productUrl = selectHref.split('?')[0];
    const urlParams = new URLSearchParams(selectHref.split('?')[1]);
    const variantId = urlParams.get('variant');
    const { sellingPlanId, variantTitle } = await fetchProductData(productUrl, variantId);
    updateProductTitle(li, variantTitle);
    if (sellingPlanId && !li.querySelector('.cw-subscription-main')) {
      const subscriptionDiv = createSubscriptionDiv(variantId, index);
      li.querySelector("h4").insertAdjacentElement('afterend', subscriptionDiv);
      setTimeout(() => {
        const sellingPlanName = li.querySelector('[x-text="item.selling_plan_allocation.selling_plan.name"]');
        setDefaultRadioSelection(sellingPlanName, subscriptionDiv);
      }, 100);
      const radioButtons = subscriptionDiv.querySelectorAll(".cw-subscription-radio");
      addRadioEventListeners(radioButtons, variantId, sellingPlanId, li, subscriptionDiv);
    }
  }
  function updateProductTitle(li, variantTitle) {
    const spanElement = li.querySelector('span[x-text="item.product_title"]');
    let existingPElement = li.querySelector('.cw-varinat-title');

    if (!existingPElement && variantTitle) {
      const pElement = document.createElement('p');
      pElement.classList.add("cw-varinat-title");
      pElement.textContent = variantTitle == "Default Title" ? "" : variantTitle;
      spanElement.insertAdjacentElement('afterend', pElement);
    }
  }
  function createSubscriptionDiv(variantId, uniqueId) {
    const subscriptionDiv = document.createElement('div');
    subscriptionDiv.classList.add("cw-subscription-main");
    const hideSubscriptionIds = ['32848728916053', '40733943169109', '39270374211669', '40817322983509', '40850678972501', '31346262048853', '32821929377877'];
    const hideSubscriptionClass = hideSubscriptionIds.includes(variantId.toString()) ? ' hide-subscription' : '';
    subscriptionDiv.innerHTML = `
          <div class="cw-subscribe-header ${hideSubscriptionClass}">
            <div class="cw-subscribe">
              <label>
                <input type="radio" name="subscription-option-${variantId}-${uniqueId}" class="cw-subscription-radio" value="one-time">
                <span></span>One-time Purchase
              </label>
              <label>
                <input type="radio" name="subscription-option-${variantId}-${uniqueId}" class="cw-subscription-radio" value="subscription">
                <span></span>Subscribe & Save
              </label>
            </div>
          </div>`;

    return subscriptionDiv;
  }

  function addRadioEventListeners(radioButtons, variantId, sellingPlanId, selectQty, subscriptionDiv) {
    radioButtons.forEach((radio) => {
      radio.addEventListener('change', async () => {
        const sellingPlan = radio.value === "subscription" ? sellingPlanId : null;
        const response = await addToCart(variantId, sellingPlan, selectQty, subscriptionDiv);
        if (response.ok) {
          console.log(`Success: ${radio.value === "subscription" ? 'Subscription' : 'One-time purchase'} product added`);
          setTimeout(subscriptionProduct, 1500);
        } else {
          console.error(`Error: Unable to add ${radio.value === "subscription" ? 'subscription' : 'one-time purchase'} product`);
        }
      });
    });
  }
  async function subscriptionProduct() {
    document.querySelectorAll('#cart-drawer .flow-root > ul > li.flex').forEach(async (li, index) => {
      if (!li.querySelector('.cw-subscription-main')) {
        //await initializeSubscriptionProduct(li, index);
        //await appendNewImage(li)
      }
    });
    console.log('######Hello from CW-subscrive#####')
  }
  function handleClassAdded() {
    subscriptionProduct();
  }

  function handleClassRemoved() {
    document.querySelectorAll('.cw-subscription-main, .cw-varinat-title').forEach(element => element.remove());
  }
  
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        console.log("Hello from the Observer...")
        document.documentElement.classList.contains('!overflow-hidden') ? handleClassAdded() : handleClassRemoved();
      }
    });
  });
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  
  // const cartDrawerWrapper = document.querySelector('.cart-drawer-item-wrapper');
  // const htmlTargetNode = document.documentElement;
  // if (cartDrawerWrapper) {
  //   const observer = new MutationObserver((mutationsList) => {
  //     mutationsList.forEach((mutation) => {
  //       if (mutation.type === 'childList') {
  //         console.log('Cart item HTML inserted, updated, or removed.');
  //         setTimeout(handleClassRemoved, 600);
  //         setTimeout(subscriptionProduct, 600);
  //       }
  //       if (mutation.type === 'attributes' && mutation.target === htmlTargetNode && mutation.attributeName === 'class') {
  //         console.log("Hello from the Observer...");
  //         document.documentElement.classList.contains('!overflow-hidden') ? handleClassAdded() : handleClassRemoved();
  //       }
  //     });
  //   });
  //   observer.observe(cartDrawerWrapper, { childList: true, subtree: true });
  //   observer.observe(htmlTargetNode, { attributes: true, attributeFilter: ['class'] });
  // }

  
  async function fetchProductData(url, variantId) {
    try {
      const response = await fetch(`${url}.js`);
      const data = await response.json();
      const sellingPlanId = data.selling_plan_groups[0]?.selling_plans[0]?.id;
      const matchingVariant = data.variants.find(variant => variant.id == variantId);
      const variantTitle = matchingVariant ? matchingVariant.title : null;

      return { sellingPlanId, variantTitle };
    } catch (error) {
      console.error('Error fetching product data:', error);
      return { sellingPlanId: null, variantTitle: null };
    }
  }
  async function addToCart(variantId, sellingPlanId, selectQty, subscriptionDiv) {
    let quentity = selectQty.querySelector(".item-data-wrapper .item-qty-input").value;
    const payload = {
      items: [{
        id: variantId,
        quantity: quentity,
        ...(sellingPlanId && { selling_plan: sellingPlanId })
      }]
    };

    try {
      const response = await fetch(`/cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      subscriptionDiv.closest('li.flex').querySelector('button[type="button"]').click();

      setTimeout(() => {
        document.querySelectorAll('.cw-subscription-main, .cw-varinat-title').forEach(element => element.remove());
      }, 1500);

      return response;
    } catch (error) {
      console.error('Error adding to cart:', error);
      return { ok: false };
    }
  }

  document.querySelectorAll('#cart-drawer .flow-root > ul > li.flex button.uline').forEach(removeButton => {
    removeButton.addEventListener('click', () => {
      setTimeout(handleClassRemoved,600);
      setTimeout(subscriptionProduct, 1500);
    });
  });

  setTimeout(subscriptionProduct, 200);

  document.addEventListener('customEvent', (event) => {
    console.log('Custom event triggered with data:', event.detail.message);
    setTimeout(handleClassRemoved, 600);
    setTimeout(subscriptionProduct, 600);
  });

  

});

// document.addEventListener("DOMContentLoaded", () => {
//   function observeCartDrawerItem() {
//     console.log('observeCartDrawerItem running...')
//     const targetNode = document.body;
//     const config = { childList: true, subtree: true };
//     const callback = (mutationsList, observer) => {
//       for (const mutation of mutationsList) {
//         if (mutation.type === 'childList') {
//           const cartItem = document.querySelector('li[data-itemid="54950252380542"]');
//           if (cartItem) {
//             console.log("Cart drawer item with data-itemid='54950252380542' exists!");
//             setTimeout(handleClassRemoved, 600);
//             setTimeout(subscriptionProduct, 600);
//             observer.disconnect();
//           }
//         }
//       }
//     };
//     const observer = new MutationObserver(callback);
//     observer.observe(targetNode, config);
//   }
//   observeCartDrawerItem();
// });
  



